import { render, staticRenderFns } from "./PeerGroupSortControl.vue?vue&type=template&id=ccd08ba2&scoped=true&"
import script from "./PeerGroupSortControl.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupSortControl.vue?vue&type=script&lang=ts&"
import style0 from "./PeerGroupSortControl.vue?vue&type=style&index=0&id=ccd08ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd08ba2",
  null
  
)

export default component.exports